export const reduceActiveRowColumns = (columns = [], rows = []) => {
  const resultColumns = [];
  for (let rowIx = 0; rowIx < rows.length; rowIx++) {
    if (resultColumns.length === columns.length) {
      break;
    }
    const row = rows[rowIx];
    for (let colIx = 0; colIx < columns.length; colIx++) {
      const column = columns[colIx];
      if (row[column] && resultColumns.indexOf(column) === -1) {
        resultColumns.push(column);
      }
    }
  }

  return columns.reduce((memo, col) => {
    if (resultColumns.indexOf(col) > -1) {
      memo.push(col);
    }
    return memo;
  }, []);
};

export const getDataFieldSets = ({ data = [], fields = [] }) =>
  data.reduce(
    (memo, row) => {
      fields.forEach((field) => {
        const fieldVal = row[field];
        if (fieldVal && memo[field].indexOf(fieldVal) === -1) {
          memo[field].push(fieldVal);
        }
      });

      return memo;
    },
    fields.reduce((memo, field) => {
      memo[field] = [];
      return memo;
    }, {})
  );
